import { Component, OnInit } from '@angular/core';
import { onSideNavChange, animateText } from '../animations/animations';
import { SidenavService } from '../services/sidenav.service';


// interface Page {
//   link: string;
//   name: string;
//   icon: string;
// }

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
  animations: [onSideNavChange, animateText]
})
export class SidenavComponent implements OnInit {

  public sideNavState: boolean = false;
  public linkText: boolean = false;

 
  // public pages: Page[] = [
  //   {name: 'Dashboard', link:'reports', icon: 'home'},
  //   {name: 'Graphical Report ', link:'/normal', icon: 'leaderboard'},
  //   {name: 'Billing Report ', link:'/normal', icon: 'money'},
  //   {name: 'Registration Report ', link:'/normal', icon: 'person'},
  //   {name: 'Appointment Report ', link:'/normal', icon: 'book_online'},
  //   {name: 'Opt-Visit Report ', link:'/normal', icon: 'style'},
  //   {name: 'Custom Report ', link:'/custom', icon: 'settings'},
  // ]


  
  constructor(private _sidenavService: SidenavService) { }

  ngOnInit() {
  }

  onSinenavToggle() {
    this.sideNavState = !this.sideNavState
    
    setTimeout(() => {
      this.linkText = this.sideNavState;
    }, 200)
    this._sidenavService.sideNavState$.next(this.sideNavState)
  }

  
}